import Button from '@mui/material/Button';
import React, { useContext } from 'react';
import { FormAContext } from '../../context/FormAContext';
import './ResetButtonA.scss';

type Props = {
    text: string,
    className: string,
    setIsCalculated: (isCalculated: boolean) => void,
}

export const ResetButtonA = (props: Props) => {
    const { setIsDisabled } = useContext(FormAContext);

    const { text, className, setIsCalculated } = props;

    return <>
        <Button
            variant='contained'
            className={className}
            onClick={() => { setIsDisabled(false); setIsCalculated(false); }} >{text}</Button>
    </>
};
